import Icon from './Icon.jsx';

/**
 * Ambient audio toggle.
 *
 * When active the button breathes — a slow scale/opacity pulse on the ring
 * behind the icon, driven by CSS so it costs nothing on the main thread and
 * respects `prefers-reduced-motion` (the pulse falls back to a static glow).
 */
export default function AmbientAudioButton({ enabled, supported, onToggle }) {
  if (!supported) return null;

  return (
    <button
      type="button"
      className={`audio-btn${enabled ? ' is-active' : ''}`}
      onClick={onToggle}
      aria-pressed={enabled}
      aria-label={enabled ? 'Turn ambient sound off' : 'Turn ambient sound on'}
      title={enabled ? 'Ambient sound on' : 'Ambient sound off'}
    >
      <span className="audio-btn__pulse" aria-hidden="true" />
      <span className="audio-btn__icon">
        <Icon name={enabled ? 'soundOn' : 'soundOff'} size={18} />
      </span>
    </button>
  );
}
